import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BusinessServices.css';
import careerDirection from '../assets/icons/career-direction.webp';
import timingWindows from '../assets/icons/timing-windows.webp';
import brandingIdentity from '../assets/icons/branding-identity.webp';
import partnershipsCompatibility from '../assets/icons/partnerships-compatibility.webp';
import businessStrategy from '../assets/icons/business-strategy.webp';
import professionalGrowth from '../assets/icons/professional-growth.webp';

const BusinessServices = () => {
  const navigate = useNavigate();
  const services = [
    {
      id: 1,
      icon: <img src={careerDirection} alt="Career Direction" className="service-icon" />,
      title: 'Career Direction & Purpose',
      subtitle: 'Find your true calling and align with your natural strengths.',
      features: [
        'Career path astrology reading',
        'Strengths & talents analysis',
        'Career change & transition timing'
      ]
    },
    {
      id: 2,
      icon: <img src={professionalGrowth} alt="Professional Growth" className="service-icon" />,
      title: 'Professional Growth & Opportunities',
      subtitle: 'Plan promotions, visibility, and recognition using astrology.',
      features: [
        'Promotion & growth forecasts',
        'Leadership style reading',
        'Workplace & boss compatibility'
      ]
    },
    {
      id: 3,
      icon: <img src={businessStrategy} alt="Business Strategy" className="service-icon" />,
      title: 'Business Astrology & Strategy',
      subtitle: 'Build and expand your business aligned with the stars.',
      features: [
        'Business astrology consultation',
        'Startup or launch timing (Muhurta)',
        'Business cycles & profitability forecast'
      ]
    },
    {
      id: 4,
      icon: <img src={partnershipsCompatibility} alt="Partnerships & Compatibility" className="service-icon" />,
      title: 'Partnerships & Team Compatibility',
      subtitle: 'Choose the right partners and strengthen collaboration.',
      features: [
        'Business partnership compatibility',
        'Co-founder & investor matching',
        'Team dynamics & synergy insights'
      ]
    },
    {
      id: 5,
      icon: <img src={brandingIdentity} alt="Branding & Identity" className="service-icon" />,
      title: 'Branding & Identity Alignment',
      subtitle: 'Create a business name, brand, and identity that magnetizes success.',
      features: [
        'Astro-branding & naming',
        'Logo & color alignment with planetary energies',
        'Market positioning insights'
      ]
    },
    {
      id: 6,
      icon: <img src={timingWindows} alt="Timing & Financial Windows" className="service-icon" />,
      title: 'Timing & Financial Windows',
      subtitle: 'Act at the right moment for investments, deals, and expansions.',
      features: [
        'Transit & Dasha-based forecasts',
        'Wealth & investment astrology',
        'Electional astrology for key business events'
      ]
    }
  ];

  return (
    <section className="bg-sand py-8">
      <div className="w-full px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div 
              key={service.id} 
              className="bg-bone/95 rounded-xl p-8 border border-indigoDeep/10 hover:border-indigoDeep/20 transition-transform duration-300 hover:scale-105 shadow-sm"
            >
              <div className="mb-4 service-icon-wrap">{service.icon}</div>
              <h3 className="font-serif text-2xl mb-2 text-indigoDeep">{service.title}</h3>
              <p className="text-grayWarm text-sm mb-6">{service.subtitle}</p>
              
              <div className="space-y-3">
                <p className="text-xs uppercase tracking-widest text-grayWarm/70 font-semibold">Includes:</p>
                <ul className="space-y-2">
                  {service.features.map((feature, index) => (
                    <li key={index} className="flex items-start text-sm text-grayWarm">
                      <span className="text-goldSoft mr-3 mt-1">✦</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <button 
                onClick={() => navigate('/booking')}
                className="w-full mt-8 bg-gradient-to-r from-goldSoft to-goldHover hover:from-goldHover hover:to-goldSoft text-indigoDeep font-semibold py-3 rounded-lg transition-shadow duration-300 shadow-sm">
                Learn More
              </button>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center bg-bone/95 rounded-xl p-12 border border-indigoDeep/10">
          <p className="text-indigoDeep text-xl mb-8 font-serif">
            Ready to align your business with the cosmic blueprint?
          </p>
          <button 
            onClick={() => navigate('/booking')}
            className="bg-gradient-to-r from-goldSoft to-goldHover hover:from-goldHover hover:to-goldSoft text-indigoDeep font-bold py-4 px-12 rounded-lg transition-all duration-300 text-lg">
            📅 Book Your Business Consultation
          </button>
        </div>
      </div>
    </section>
  );
};

export default BusinessServices;
